export default __webpack_public_path__ + "static/media/2-Ibrahim-Hvilken betydning hadde identiteten din for flukten.52ccc10a.mp4";